export enum BetSlipTypes {
    SINGLE = 'single',
    COMBINATION = 'combination',
    SYSTEM = 'system'
}